<mat-toolbar-row class="table-toolbar white border-solid border-0 border-b border-gray-200">
    <div fxLayout="row">
        <app-search-outline [searchInput]="searchInput"></app-search-outline>

        <div class="header-buttons ml-16" fxLayout="row" fxLayoutAlign="end center" *ngIf="hasPermissions">
            <app-flat-button
                fxHide
                fxShow.gt-sm
                [color]="'warn'"
                [label]="'GENERAL.BUTTON.REMOVE_SELECTED'"
                (onClick)="deleteSelected()"
                *ngIf="(selectedManagerId$ | async).length; let numberOfSelectedManagers"
            ></app-flat-button>

            <app-flat-button
                [icon]="'person_add'"
                [label]="'LIST.MODULE_MANAGERS.BUTTON.ADD'"
                (onClick)="openAddManagersDialog()"
                *ngIf="!(selectedManagerId$ | async).length"
            ></app-flat-button>

            <button fxHide.gt-sm mat-icon-button class="min-width-auto px-8" [matMenuTriggerFor]="menu" aria-label="More" (click)="$event.stopPropagation()">
                <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item *ngIf="(selectedManagerId$ | async).length; let numberOfSelectedManagers" (click)="deleteSelected()">
                    <span>{{ 'GENERAL.BUTTON.REMOVE_SELECTED' | translate }}</span>
                </button>

                <button mat-menu-item (click)="openAddManagersDialog()">
                    <span>{{ 'LIST.MODULE_MANAGERS.BUTTON.ADD' | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
</mat-toolbar-row>

<mat-table #table [dataSource]="dataSource" matSort>
    <!-- Checkbox Column -->
    <ng-container matColumnDef="checkbox">
        <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selectedManagerIds.length && isAllSelected()"
                [indeterminate]="selectedManagerIds.length && !isAllSelected()"
            >
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let manager">
            <mat-checkbox [(ngModel)]="checkboxes[manager.id]" (ngModelChange)="onSelectedChange(manager.id)" (click)="$event.stopPropagation()"> </mat-checkbox>
        </mat-cell>
    </ng-container>
    <!-- Avatar Column -->
    <ng-container matColumnDef="avatar">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell class="user-details-card-container" *matCellDef="let manager">
            <div class="relative" #avatarCell>
                <img class="avatar" *ngIf="manager?.user.avatar.src; else initials" [alt]="manager.user.fullName" [src]="manager.user.avatar.src" />
                <ng-template #initials>
                    <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ manager.user.fullName | initials }}</div>
                </ng-template>
                <ng-template [onlineStateIndicator]="manager.user.isOnline"> </ng-template>
            </div>
            <app-user-details-card [user]="manager.user" [target]="avatarCell" [isTitleClickable]="false" openedFrom="contact_card_managers"></app-user-details-card>
        </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="fullName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
        <mat-cell class="user-details-card-container" *matCellDef="let manager">
            <p #nameRow class="text-truncate">{{ manager.user.fullName }}</p>
            <app-user-details-card [user]="manager.user" [target]="nameRow" [isTitleClickable]="false" openedFrom="contact_card_managers"></app-user-details-card>
        </mat-cell>
    </ng-container>

    <!-- Email Column -->
    <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.EMAIL' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let manager" fxHide fxShow.gt-sm>
            <a [href]="'mailto:' + manager.user.email" target="_top">{{ manager.user.email }}</a>
        </mat-cell>
    </ng-container>

    <!-- Buttons Column -->
    <ng-container matColumnDef="buttons">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let manager">
            <div fxFlex="row" fxLayoutAlign="end center">
                <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                    <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                </button>

                <mat-menu #moreMenu="matMenu" xPosition="before">
                    <app-menu-item-button aria-label="edit" [icon]="'edit'" [label]="'GENERAL.LABEL.EDIT_USER_PROFILE'" (onClick)="editManager(manager)"></app-menu-item-button>

                    <app-menu-item-button
                        aria-label="edit"
                        [icon]="'edit'"
                        [label]="'GENERAL.LABEL.EDIT_MANAGER_PERMISSIONS'"
                        (onClick)="editManagerPermissions(manager)"
                    ></app-menu-item-button>

                    <app-menu-item-button
                        aria-label="remove"
                        [svgIcon]="'delete'"
                        [label]="module.kind === ModuleKind.ProgramExecution ? 'LIST.MODULE_PARTICIPANTS.BUTTON.REMOVE_FROM_PROGRAM' : 'LIST.MODULE_PARTICIPANTS.BUTTON.REMOVE'"
                        (onClick)="deleteSelected(manager)"
                    ></app-menu-item-button>
                </mat-menu>
            </div>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let manager; columns: displayedColumns" class="manager" [ngClass]="{ 'accent-50': checkboxes[manager.id] }" matRipple> </mat-row>
</mat-table>
